import React, { useEffect, useState, useMemo } from "react";
import { Form, notification, Space } from "antd";
import { useParams } from "react-router";
import { useGetDomainGymQuery, useEditGymMutation } from "store/api/api";
import { DividerHeader } from "components/Common/DividerHeader";
import { Button } from "components/Common/Button";
import { FormTextArea } from "components/Common/Form/FormTextArea";
import { required } from "helpers/Form/commonFormValidations";

const MembershipSubscriptionDescription = () => {
	const { gym } = useParams();
	const [form] = Form.useForm();
	const description = Form.useWatch("description", form);
	const [initialDescription, setInitialDescription] = useState("");

	const { data: domainGymData, refetch, isLoading: isLoadingDomainGym } = useGetDomainGymQuery(gym, { skip: !gym });
	const [editGymTrigger, { isLoading: editGymLoading }] = useEditGymMutation();

	useEffect(() => {
		if (domainGymData) {
			const description = domainGymData.member_subscription_description || "";
			setInitialDescription(description);
			form.setFieldsValue({ description });
		}
	}, [domainGymData, form]);

	const onFinish = async ({ description }) => {
		if (description === initialDescription) return;

		try {
			await editGymTrigger({
				gym_id: domainGymData.id,
				member_subscription_description: description,
			}).unwrap();

			notification.success({ message: "Your details have been saved!" });
			setInitialDescription(description);
			refetch();
		} catch (e) {
			notification.error({ message: "An error occurred while saving your information" });
		}
	};

	const isButtonDisabled = useMemo(() => {
		return editGymLoading || isLoadingDomainGym || description === initialDescription;
	}, [editGymLoading, isLoadingDomainGym, description, initialDescription]);

	return (
		<div>
			<DividerHeader text="Member Subscription Settings" uppercase />
			<Form form={form} onFinish={onFinish} layout="vertical" initialValues={{ description: initialDescription }}>
				<Space style={{ width: "100%" }} direction="vertical" size="large">
					<FormTextArea
						name="description"
						label="Member Subscription Description"
						rules={[
							() => ({
								validator(_, value) {
									const validationStatus = required(value);
									if (validationStatus) return Promise.reject(new Error(validationStatus));
									if (value.length > 1024) return Promise.reject(new Error("Maximum allowed characters is 1024"));
									return Promise.resolve();
								},
							}),
						]}
						rows={4}
					/>

					<Button
						className="primary-filled"
						type="submit"
						uppercase
						disabled={isButtonDisabled}
						loading={editGymLoading || isLoadingDomainGym}
					>
						Save
					</Button>
				</Space>
			</Form>
		</div>
	);
};

export default MembershipSubscriptionDescription;

